import { Inject, Injectable } from "@angular/core";
import { azure } from "fine-uploader/lib/azure";

import { AuthenticationService } from "../user/authentication.service";
import { ENVIRONMENT } from "../../token";

@Injectable()
export class AzureStorageService {
	public uploader: azure.FineUploaderBasic;
	public urlSuccess: string = "";
	public urlAzure: string = "";
	public urlToken: string = "";
	// tslint:disable-next-line:max-line-length
	// tslint:disable-next-line:ban-types
	public auxCallback!: Function;

	constructor(@Inject(ENVIRONMENT) protected environment, private auth_service: AuthenticationService) {
		this.urlSuccess = environment.api_url + "/v2/azure/upload/success";
		this.urlAzure = environment.azureVariables.url;
		this.urlToken = environment.api_url + "/v2/azure/blob/sas_token";

		this.uploader = new azure.FineUploaderBasic({
			debug: false,
			maxConnections: 3,
			cors: {
				expected: true,
				sendCredentials: true,
			},
			chunking: {
				enabled: true,
				partSize: 4000000,
				concurrent: {
					enabled: true,
				},
			},
			request: {
				endpoint: this.urlAzure,
			},
			validation: {
				allowedExtensions: ["bmp", "png", "jpeg", "jpg", "svg", "pdf", "zip", "msi", "pkg", "hbs"],
				stopOnFirstInvalidFile: false,
				sizeLimit: 1073741824,
			},
			messages: {
				typeError: "{file} has an invalid extension. Valid extension(s): {extensions}.",
				sizeError: "{file} is too large, maximum file size is {sizeLimit}.",
			},
			signature: {
				endpoint: this.urlToken,
			},
			uploadSuccess: {
				endpoint: this.urlSuccess,
			},
			callbacks: {
				// tslint:disable-next-line:only-arrow-functions
				onSubmit: (id: any, name: any) => {
					console.log("onSubmit", id, name);
				},
				onProgress: (id: any, name: any, uploadedBytes: any, totalBytes: any) => {
					console.log("onProgress", id, name, uploadedBytes, totalBytes);
				},
				onComplete: (id: any, name: any, responseJSON: any) => {
					if (this.auxCallback) {
						this.auxCallback(null, { response: responseJSON });
					}
				},
				onAllComplete: (succeeded: any, failed: any) => {},
				onError: (id: any, name: any, error: any) => {
					console.error(error);
					if (this.auxCallback) {
						this.auxCallback(true);
					}
				},
				onCancel: (id: any, name: any) => {
					// Do something
				},
			},
		});
	}

	// tslint:disable-next-line:ban-types
	public uploadBlobToServer(file?: File, callback?: Function): void {
		this.auxCallback = callback!;
		this.uploader.addFiles(file);
	}
}
